module.exports = __webpack_public_path__ + "static/media/carta_25.8d18713b.jpg";